import { SortOrder } from '@approvalmax/ui/src/components';

import { SortingDirection } from './XeroBillBatchPaymentForm.types';

export const tableSortOrderToSortingDirectionMap = {
    [SortOrder.asc]: SortingDirection.Ascending,
    [SortOrder.desc]: SortingDirection.Descending,
};
